/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./scene-text.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./scene-text.component";
var styles_SceneTextComponent = [i0.styles];
var RenderType_SceneTextComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_SceneTextComponent, data: {} });
export { RenderType_SceneTextComponent as RenderType_SceneTextComponent };
export function View_SceneTextComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [["id", "scene_text_wrap"]], [[8, "className", 0]], null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["\n\n"])), (_l()(), i1.ɵted(-1, null, ["\n"]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = i1.ɵinlineInterpolate(1, "scene_text_", _co.practiceIndex, ""); _ck(_v, 0, 0, currVal_0); }); }
export function View_SceneTextComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-scene-text", [], null, null, null, View_SceneTextComponent_0, RenderType_SceneTextComponent)), i1.ɵdid(1, 4308992, null, 0, i2.SceneTextComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SceneTextComponentNgFactory = i1.ɵccf("app-scene-text", i2.SceneTextComponent, View_SceneTextComponent_Host_0, { content: "content", practiceIndex: "practiceIndex", picture: "picture" }, {}, []);
export { SceneTextComponentNgFactory as SceneTextComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/scene-text/scene-text.component.ngfactory.js.pre-build-optimizer.js